<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 1L8 8L1 1"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";
defineProps({
  color: {
    type: String,
    default: "#003D6A",
  },
  width: {
    type: [String, Number],
    default: "16",
  },
  height: {
    type: [String, Number],
    default: "9",
  },
});
</script>
